import React, {useMemo} from "react"
import {ScrollableTable, TableBody, TableHead} from "./ScrollableTable"
import {Box, TableCell, TableRow, useTheme} from "@mui/material"
import {getMerkmal} from "../../../misc/widget-functions"
import {fmtAlways} from "./AvRiesterTable"

const WertentwicklungTable = ({widget, getDataFromPointer}) => {
    const pointer = getMerkmal(widget)?.pointer
    const {depot} = getDataFromPointer(pointer) ?? {}

    const {
        secondary: eigenbeitraege,
        tertiary: foerderung,
        quartary: gesamtkapital,
        primary: vorhandenesRiesterkapital,
    } = useTheme()?.AvRiester ?? {}

    const tableRows = useMemo(
        () => [
            {
                key: "gesamtkapital",
                label: "Wertentwicklung",
                color: gesamtkapital,
            },
            {key: "foerderung", label: "Förderung", color: foerderung},
            {
                key: "eigenbeitraege",
                label: "Eigenbeiträge",
                color: eigenbeitraege,
            },
            {
                key: "vorhandenesRiesterkapital",
                label: "vorhandenes Riesterkapital",
                color: vorhandenesRiesterkapital,
            },
        ],
        [foerderung, eigenbeitraege, gesamtkapital, vorhandenesRiesterkapital],
    )

    return (
        <ScrollableTable noWrap>
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="right">Altersvorsorgedepot</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {tableRows.map(({key, label, color}) => (
                    <TableRow key={key}>
                        <TableCell>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                }}>
                                {color && (
                                    <Box
                                        sx={{
                                            width: 16,
                                            height: 16,
                                            borderRadius: "50%",
                                            bgcolor: color,
                                            flexShrink: 0,
                                        }}
                                    />
                                )}
                                {label}
                            </Box>
                        </TableCell>
                        <TableCell align="right">
                            {fmtAlways(depot?.[key], false, 2)}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </ScrollableTable>
    )
}

export default WertentwicklungTable
